import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultVerificationMetricResource,
    useVerificationMetricActions,
    VerificationMetricMutationResourceSchema,
} from '../../../../../resource/resources/artifacts/verification_metric/verificationMetricResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { VerificationMetricContent } from './VerificationMetricContent';

export const VerificationMetricEditDialog = ({
    onClose,
    objectId,
    versionedInId,
}: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const verificationMetricActions = useVerificationMetricActions();
    const verificationMetricQuery = verificationMetricActions.useGetResourceByObjectIdAndVersionedIn(
        objectId,
        versionedInId
    );
    const updateVerificationMetric = verificationMetricActions.useUpdateResource();
    const validation = verificationMetricActions.useValidateResource(verificationMetricQuery.data?.id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: VerificationMetricMutationResourceSchema,
        defaultValues: defaultVerificationMetricResource,
        submitHandler: async (data) => {
            await updateVerificationMetric.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: verificationMetricQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit Verification Metric'}
            resourceType={ResourceType.VERIFICATION_METRIC}
            resourceValidationResult={validation.data}
            metaDataInfo={verificationMetricQuery.data}
        >
            <QueryBaseComponent name="VerificationMetric" query={verificationMetricQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <VerificationMetricContent
                        form={form}
                        formNames={formNames}
                        readOnly={readOnly}
                        id={verificationMetricQuery.data?.id}
                    />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
